export const formatToggleValue = (value?: boolean) => (value ? "On" : "Off");
